// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 1024px)";
var _3 = "screen and (max-width: 600px)";
var _4 = "slider-GSPrA";
var _5 = "container-25vmZ";
var _6 = "inside-1YpcD";
var _7 = "elementsWrapper-iNFkT";
var _8 = "arrow_next-1RFeq";
var _9 = "arrow_prev-y989w";
var _a = "disabled-2PwxJ";
export { _1 as "__esModule", _2 as "tablet", _3 as "mobile", _4 as "slider", _5 as "container", _6 as "inside", _7 as "elementsWrapper", _8 as "arrow_next", _9 as "arrow_prev", _a as "disabled" }
export default { "__esModule": _1, "tablet": _2, "mobile": _3, "slider": _4, "container": _5, "inside": _6, "elementsWrapper": _7, "arrow_next": _8, "arrow_prev": _9, "disabled": _a }
